import React, { useState } from "react";
import "../Layout/Layout.css";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";
import Modal from "../Modal/Modal";
const cardData = [
  {
    id: 1,
    image: "lgf.webp",
    title: "Lower Ground Floor",
  },
  {
    id: 2,
    image: "ugf.webp",
    title: "Upper Ground Floor",
  },
  {
    id: 3,
    image: "ff.webp",
    title: "First Floor",
  },
  {
    id: 4,
    image: "sf.webp",
    title: "Second Floor",
  },
  {
    id: 5,
    image: "tf.webp",
    title: "Third Floor",
  },
  {
    id: 6,
    image: "sp.webp",
    title: "Site Plan",
  },
];

const Layout = () => {
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    mobile: "",
    query: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const openModal = () => setShowModal(true);
  const hideModal = () => setShowModal(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let errors = { ...formErrors };
    switch (name) {
      case "name":
        errors.name = /^[A-Za-z\s]+$/.test(value)
          ? ""
          : "Name should contain only alphabets.";
        break;
      case "email":
        errors.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? ""
          : "Invalid email address.";
        break;
      case "mobile":
        errors.mobile = /^\d{10}$/.test(value)
          ? ""
          : "Mobile number should be 10 digits.";
        break;
      case "query":
        errors.query =
          value.length >= 15
            ? ""
            : "Query should be at least 15 characters long.";
        break;
      default:
        break;
    }
    setFormErrors(errors);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);

    // Check if there are any validation errors
    if (Object.values(formErrors).some((error) => error)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please fix the errors in the form.",
      });
      setSubmitting(false);
      return;
    }

    // Send the email using EmailJS
    emailjs
      .send(
        "YOUR_SERVICE_ID", // Replace with your EmailJS service ID
        "YOUR_TEMPLATE_ID", // Replace with your EmailJS template ID
        formValues,
        "YOUR_USER_ID", // Replace with your EmailJS user ID
      )
      .then(
        () => {
          Swal.fire({
            icon: "success",
            title: "Submitted!",
            text: "Your query has been successfully sent.",
          });
          setFormValues({ name: "", email: "", mobile: "", query: "" }); // Reset form values
          hideModal();
        },
        () => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to send your query. Please try again later.",
          });
        },
      )
      .finally(() => {
        setSubmitting(false);
      });
  };
  return (
    <>
      <div className="full-back">
        <h2 className="la-head">
          Our <span className="highlight">Layouts</span>
        </h2>
        <div className="background">
          <div className="grid">
            {cardData.map((card) => (
              <div key={card.id} className="card" onClick={openModal}>
                <img src={card.image} alt={card.title} />
                <div className="title-l">{card.title}</div>
                <span className="line top padded" />
                <span className="line left padded" />
                <span className="line bottom padded" />
                <span className="line right padded" />
              </div>
            ))}
          </div>
        </div>

        <Modal show={showModal} handleClose={hideModal}>
          <h2 className="modal-heading">Get More Details</h2>
          <form className="modal-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formValues.name}
                onChange={handleChange}
                className={`input ${formErrors.name ? "invalid" : ""}`}
                required
              />
              {formErrors.name && (
                <span className="error">{formErrors.name}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formValues.email}
                onChange={handleChange}
                className={`input ${formErrors.email ? "invalid" : ""}`}
                required
              />
              {formErrors.email && (
                <span className="error">{formErrors.email}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="mobile">Mobile:</label>
              <input
                type="tel"
                id="mobile"
                name="mobile"
                value={formValues.mobile}
                onChange={handleChange}
                className={`input ${formErrors.mobile ? "invalid" : ""}`}
                required
              />
              {formErrors.mobile && (
                <span className="error">{formErrors.mobile}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="query">Your Query:</label>
              <textarea
                id="query"
                name="query"
                value={formValues.query}
                onChange={handleChange}
                className={`input ${formErrors.query ? "invalid" : ""}`}
                rows="4"
                required
              />
              {formErrors.query && (
                <span className="error">{formErrors.query}</span>
              )}
            </div>
            <div className="butt-f">
              <button className="button-3" type="submit" disabled={submitting}>
                {submitting ? "Submitting..." : "SUBMIT"}
              </button>
            </div>
          </form>
        </Modal>
      </div>
    </>
  );
};

export default Layout;
